import React from 'react';
import * as styles from './index.module.less';

interface IProps {
  children?: any;
  className?: string;
}

const OffTag = ({ children, className }: IProps) => {
  return <div className={`${className} ${styles.tag_wrapper}`}>{children}</div>;
};
export default OffTag;
